import React from 'react';
import PropTypes from 'prop-types';
import apiClient from '../utils/apiClient';
import AppRateComponent from '../components/AppRateComponent';

const ASK_FOR_FEEDBACK_BELOW_RATE = 6;

class AppRateContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      rating: null,
      askForAdditionalFeedback: false,
      sentRatingId: null,
      feedback: '',
      ratingEnd: false
    };

    this.onStarClick = this.onStarClick.bind(this);
    this.sendRating = this.sendRating.bind(this);
    this.handleFeedbackChange = this.handleFeedbackChange.bind(this);
    this.sendFeedback = this.sendFeedback.bind(this);
  }

  onStarClick(nextValue) {
    this.setState({ rating: nextValue });
  }

  sendRating() {
    apiClient
      .post('/api/v1/app-rate/', {
        value: this.state.rating
      })
      .then(response => {
        const { data } = response;
        this.props.setItShouldFinishRating(true);
        if (data.value < ASK_FOR_FEEDBACK_BELOW_RATE) {
          this.setState({
            askForAdditionalFeedback: true,
            sentRatingId: data.id
          });
        } else {
          this.setState({
            ratingEnd: true
          });
        }
      });
  }

  handleFeedbackChange(event) {
    const { value } = event.target;
    this.setState({
      feedback: value
    });
  }

  sendFeedback() {
    apiClient
      .put('/api/v1/app-rate/', {
        id: this.state.sentRatingId,
        feedback: this.state.feedback
      })
      .then(() => {
        this.setState({
          ratingEnd: true
        });
      });
  }

  render() {
    return (
      <AppRateComponent
        ratingEnd={ this.state.ratingEnd }
        sentRatingId={ this.state.sentRatingId }
        sendRating={ this.sendRating }
        onStarClick={ this.onStarClick }
        rating={ this.state.rating }
        askForAdditionalFeedback={ this.state.askForAdditionalFeedback }
        feedback={ this.state.feedback }
        handleFeedbackChange={ this.handleFeedbackChange }
        sendFeedback={ this.sendFeedback }
        onClose={ this.props.onClose }
        onFinish={ this.props.onFinish }
      />
    );
  }
}

AppRateContainer.propTypes = {
  onClose: PropTypes.func.isRequired,
  onFinish: PropTypes.func.isRequired,
  setItShouldFinishRating: PropTypes.func.isRequired
};

export default AppRateContainer;



// WEBPACK FOOTER //
// ./src/containers/AppRateContainer.js